import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';
import * as StateAdviceActions from './advice.actions';
import { StateAdviceEntity } from '../../models/advice.models';

export const _STATE_ADVICE_FEATURE_KEY = 'stateAdvice';

export interface State extends EntityState<StateAdviceEntity> {
	categories: any;
	categoriesLoaded: boolean;
	articles: any;
	articlesLoaded: boolean;
	featured: any;
	singleArticle: any;
	search: any;
	searchTerm: any;
	page: any;
	offset: any;
	error: string | null;
}

export const stateAdviceAdapter: EntityAdapter<StateAdviceEntity> =
	createEntityAdapter<StateAdviceEntity>();

export const initialState: State = stateAdviceAdapter.getInitialState({
	categories: null,
	categoriesLoaded: false,
	articles: null,
	articlesLoaded: false,
	featured: null,
	singleArticle: null,
	search: null,
	searchTerm: null,
	page: null,
	offset: null,
	error: null,
});

const stateAdviceReducer = createReducer(
	initialState,
	//CATEGORIES
	on(StateAdviceActions.fetchCategories, (state) => ({
		...state,
		categoriesLoaded: false,
		error: null,
	})),
	on(StateAdviceActions.updateCategories, (state, { categories }) => ({
		...state,
		categories: categories,
		categoriesLoaded: true,
		error: null,
	})),
	//ALL ARTICLES
	on(StateAdviceActions.fetchAllArticles, (state) => ({
		...state,
		articlesLoaded: false,
		error: null,
	})),
	on(StateAdviceActions.updateAllArticles, (state, { articles }) => ({
		...state,
		articles: articles,
		articlesLoaded: true,
		error: null,
	})),
	//GENERAL FAILURE
	on(StateAdviceActions.loadAdviceFailure, (state, { error }) => ({
		...state,
		error: error,
	})),
	//FEATURED & EDITORS CHOICE
	on(
		StateAdviceActions.fetchFeatured,
		StateAdviceActions.fetchFeaturedWithCategory,
		(state) => ({
			...state,
			featured: null,
			error: null,
		}),
	),
	on(StateAdviceActions.updateFeatured, (state, { featured }) => ({
		...state,
		featured: featured,
		error: null,
	})),
	//SINGLE ARTICLES
	on(StateAdviceActions.fetchSingleArticle, (state) => ({
		...state,
		singleArticle: null,
		error: null,
	})),
	on(StateAdviceActions.updateSingleArticle, (state, { singleArticle }) => ({
		...state,
		singleArticle: singleArticle,
		error: null,
	})),
	//SEARCH
	on(StateAdviceActions.fetchSearchAdvice, (state) => ({
		...state,
		error: null,
	})),
	on(StateAdviceActions.updateSearchParams, (state, { searchTerm, page, offset }) => ({
		...state,
		searchTerm: searchTerm,
		page: page,
		offset: offset,
	})),
	on(StateAdviceActions.updateSearchAdvice, (state, { search }) => ({
		...state,
		search: search,
		error: null,
	})),
);

export function reducer(state: State | undefined, action: Action) {
	return stateAdviceReducer(state, action);
}
